<template>
  <CloseHeader @close="goToMain" />

  <div class="app-container one-page">
    <div class="fst-step-con">
      <div class="gauge-bar">
        <span class="bar-bg"></span>
        <span class="active"></span>
      </div>
      <div class="inr-con">
        <h1>
          <i18n-t keypath="choose_your_language">
            <template #language>
              <span class="primary">{{ t('label_language') }}</span>
            </template>
          </i18n-t>
        </h1>
        <PopupSelectLanguage @confirm="handleLanguage" />
      </div>
    </div>

    <div class="app-btn-wrap">
      <button type="button" class="primary-btn l-btn" @click="goToNextStep">
        <span>{{ t('next') }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { updateEmployee } from '@/api/apiService';
import CloseHeader from '@/components/domains/mobile/common/CloseHeader.vue';
import PopupSelectLanguage from '@/components/domains/mobile/popup/PopupSelectLanguage.vue';
import { usePopupStore } from '@/stores/popup';
import { useUserStore } from '@/stores/user';
import { Language } from '@/types/common';

const { t } = useI18n();
const router = useRouter();

const popupStore = usePopupStore();
const userStore = useUserStore();

const selectedLanguage = ref<Language | null>(null);

const handleLanguage = (language: Language) => {
  selectedLanguage.value = language;
};

const goToMain = () => {
  router.replace({ name: 'app-main-view' });
};

const goToNextStep = async () => {
  if (!selectedLanguage.value) {
    popupStore.openToast(t('error_input_no_language'));
    return;
  }

  try {
    const { nickname, userId } = userStore.userInfo || {};

    const { success } = await updateEmployee(userId, null, {
      body: JSON.stringify({
        nickname,
        languageCode: selectedLanguage.value.code,
        groupIds: [],
        sampleRate: '16000',
      }),
      voice: '',
    });

    if (!success) {
      popupStore.openToast(t('PROVIDER_ERROR'));
      return;
    }

    router.replace({ name: 'app-onboarding-step2' });
  } catch {
    popupStore.openToast(t('PROVIDER_ERROR'));
    return;
  }
};
</script>

<style scoped lang="scss">
.app-container {
  overflow: hidden;
}
.fst-step-con {
  // border: 1px solid red;
  .gauge-bar {
    position: relative;
    padding: 1rem 0;
    .bar-bg {
      display: block;
      background: $gray10;
      border-radius: 100px;
      height: $size-s;
      width: 100%;
    }
    .active {
      background: $color-gray-900;
      width: 33.3%;
      height: $size-s;
      position: absolute;
      left: 0;
      top: 1rem;
      border-radius: 100px;
    }
  }
  .inr-con {
    overflow-y: auto;
    height: 100%;
    &::-webkit-scrollbar {
      display: none;
    }
    h1 {
      font-size: 1.5rem;
      padding: 2rem 0 1.5rem;
      line-height: 130%;
      span {
        font-size: 1.5rem;
        line-height: 130%;
      }
    }
    :deep(.line-sel-wrap) {
      max-height: calc(100dvh - 311px);
      min-height: calc(100dvh - 311px);
    }
  }
}
.app-btn-wrap {
  padding-bottom: 1.25rem;
  button {
    width: 100%;
  }
}
</style>
